import { useEffect, useState } from 'react'

export type ToastType = 'error' | 'success' | 'info'

interface Toast {
  id: number
  message: string
  type: ToastType
}

let addToastFn: ((msg: string, type: ToastType) => void) | null = null

export function toast(message: string, type: ToastType = 'error') {
  addToastFn?.(message, type)
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState<Toast[]>([])

  useEffect(() => {
    addToastFn = (message, type) => {
      const id = Date.now()
      setToasts((prev) => [...prev, { id, message, type }])
      setTimeout(() => setToasts((prev) => prev.filter((t) => t.id !== id)), 3500)
    }
    return () => { addToastFn = null }
  }, [])

  const colors: Record<ToastType, string> = {
    error: 'bg-[var(--color-surface)] border-[var(--color-error)]/60 text-[var(--color-error)]',
    success: 'bg-[var(--color-surface)] border-[var(--color-success)]/60 text-[var(--color-success)]',
    info: 'bg-[var(--color-surface)] border-[var(--color-border-accent)]/50 text-[var(--color-accent)]',
  }
  const icons: Record<ToastType, string> = { error: '✕', success: '✓', info: 'ℹ' }

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-2 max-w-xs w-full">
      {toasts.map((t) => (
        <div key={t.id} className={`flex items-start gap-3 px-4 py-3 rounded-xl border text-sm shadow-lg ${colors[t.type]} animate-fade-in`}>
          <span className="font-bold mt-0.5">{icons[t.type]}</span>
          <span>{t.message}</span>
        </div>
      ))}
    </div>
  )
}
